import React, {useMemo} from 'react'
import {useRouteMatch} from "react-router-dom";
import { useTranslation } from "@/langs/useTranslation";
import RawBreadCrumbs from "@/components/BreadCrumbs";
import {Box, Typography} from "@material-ui/core";
import TemplateFrom from "./AndroidTemplateForm";


const TemplateList = () => {
  const { t, userLanguage } = useTranslation();
  const editMode = useRouteMatch({
    path: "/profile-config/edit-template-android/:id"
  });
  const readOnly = useRouteMatch({
    path: "/profile-config/template-android/:id"
  });
  const isHistory = useRouteMatch({
    path: "/profile-config/install-history/:id"
  })

  const BreadCrumbs = useMemo(() => RawBreadCrumbs(isHistory?
    [
      {name: t({defaultMessage: "安装历史"}), to: '/profile-config/install-history'}
    ] :
    [
      {name: t({defaultMessage: "配置文件"}), to: '/profile-config/template'}
  ]), [])

  const pageName = useMemo(() => {
    if (editMode) return t({ defaultMessage: "编辑配置模板" })
    if (readOnly) return t({ defaultMessage: "查看配置模板" })
    if (isHistory) return t({ defaultMessage: "查看配置文件" })
    return t({ defaultMessage: "新建配置模板" })
  }, [userLanguage, editMode, readOnly, isHistory])

  return (
    <>
      <BreadCrumbs pageName={pageName} />
      <Box display="flex" flex={1} flexDirection="column">
        { !isHistory && (
          <Typography variant="h4" style={{marginBottom: 24}}>
            {pageName}
          </Typography>
        )}
        <TemplateFrom isHistory={!!isHistory} readOnly={!!readOnly || !!isHistory} id={editMode?.params?.id || readOnly?.params?.id || isHistory?.params?.id} />
      </Box>
    </>
  );
};

export default TemplateList;
